module.exports = __webpack_public_path__ + "img/icon_non_elettrico.82aa534c.png";